import {
  CreateTriggerRequest,
  Trigger,
  TriggerName,
  TriggerType,
} from "@app/entities/triggers";
import { Api, ApiResponse } from "./_base";

export async function loadTriggers(
  companyId: number
): Promise<ApiResponse<{ data: Trigger[] }>> {
  return Api.execute({
    url: `/api/trigger`,
    params: {
      triggerType: TriggerType.System,
      taskType: TriggerName.SalesforceNotification,
      companyId,
    },
  });
}

export function createTrigger(
  data: CreateTriggerRequest,
  companyId: number
): Promise<ApiResponse<Trigger>> {
  return Api.execute({
    url: `/api/trigger`,
    method: "POST",
    data,
    params: {
      companyId: companyId,
    },
  });
}
